import { useState } from "react";
import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";

export function LabSamplesDetailsViewModel(logout, id, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [labSample, setLabSample] = useState({
    lab_id: null,
    barcode: null,
    manufactured_product_id: null,
    lot_number: null,
    plu: null,
    product_name: null,
    weight_in_kg: null,
    weight_in_lbs: null,
    piece_count: null,
    created_date: Date.now(),
  });
  const [labs, setLabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inProgress, setInProgress] = useState(false);

  const getLabSampleDetails = async function () {
    let callResult = await makeGetApiCall(`labSamples/${id}`);

    if (callResult.success) {
      setLabSample(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  const getLabsForDropdown = async function () {
    let callResult = await makePostApiCall(`laboratoriesForDropdown`);

    if (callResult.success) {
      setLabs(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  const updateLabSample = async function (payload) {
    setInProgress(true);
    // Support payload.status and payload.laboratory being either objects
    // (from react-select: { value, label }) or primitive values.
    const statusValue =
      payload && typeof payload.status === "object" && payload.status !== null
        ? payload.status.value
        : payload && payload.status !== undefined
        ? payload.status
        : null;

    const labIdValue =
      payload &&
      typeof payload.laboratory === "object" &&
      payload.laboratory !== null
        ? payload.laboratory.value
        : payload && payload.laboratory !== undefined
        ? payload.laboratory
        : null;

    let callResult = await makePostApiCall(
      `labSamples/${id}/update`,
      {
        ...payload,
        status: statusValue,
        lab_id: labIdValue,
        laboratory: null,
      },
      "multipart/form-data"
    );

    if (callResult.success) {
      let message = "Lab sample updated successfully";
      addSnackbar(
        new SnackbarData(generateUniqueNumber(), message, SnackbarType.Success)
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setInProgress(false);
    return callResult;
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    loading,
    labSample,
    getLabSampleDetails,
    updateLabSample,
    inProgress,
    labs,
    getLabsForDropdown,
  };
}
